import { render, staticRenderFns } from "./auction-view-page.vue?vue&type=template&id=3fa90f29&scoped=true&"
import script from "./auction-view-page.vue?vue&type=script&lang=js&"
export * from "./auction-view-page.vue?vue&type=script&lang=js&"
import style0 from "./auction-view-page.vue?vue&type=style&index=0&id=3fa90f29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa90f29",
  null
  
)

export default component.exports
import {QSkeleton,QAvatar,QIcon,QImg,QCarousel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton,QAvatar,QIcon,QImg,QCarousel})
